!function (e, t) {
  for (var n in t) {
    e[n] = t[n];
  }
}(exports, function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 18);
}([function (e, t) {
  e.exports = require("@babel/runtime/helpers/extends");
}, function (e, t) {
  e.exports = require("@redux-saga/is");
}, function (e, t) {
  e.exports = require("@babel/runtime/helpers/defineProperty");
}, function (e, t) {
  e.exports = require("redux-saga/effects");
}, function (e, t) {
  e.exports = require("@babel/runtime/regenerator");
}, function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("redux");
}, function (e, t) {
  e.exports = require("@babel/runtime/helpers/typeof");
}, function (e, t) {
  e.exports = require("@babel/runtime/helpers/objectWithoutProperties");
}, function (e, t) {
  e.exports = require("@babel/runtime/helpers/classCallCheck");
}, function (e, t) {
  e.exports = require("@babel/runtime/helpers/createClass");
}, function (e, t) {
  e.exports = require("@babel/runtime/helpers/possibleConstructorReturn");
}, function (e, t) {
  e.exports = require("@babel/runtime/helpers/getPrototypeOf");
}, function (e, t) {
  e.exports = require("@babel/runtime/helpers/assertThisInitialized");
}, function (e, t) {
  e.exports = require("@babel/runtime/helpers/inherits");
}, function (e, t) {
  e.exports = require("prop-types");
}, function (e, t) {
  e.exports = require("react-redux");
}, function (e, t) {
  e.exports = require("hoist-non-react-statics");
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = {};
  n.r(r), n.d(r, "showModal", function () {
    return j;
  }), n.d(r, "hideModal", function () {
    return k;
  }), n.d(r, "clickModal", function () {
    return q;
  }), n.d(r, "updateModal", function () {
    return S;
  }), n.d(r, "destroyModal", function () {
    return w;
  }), n.d(r, "submitModal", function () {
    return C;
  });
  var o = n(2),
      a = n.n(o),
      u = n(0),
      i = n.n(u),
      c = "@@modal-saga/SHOW",
      s = "@@modal-saga/UPDATE",
      l = "@@modal-saga/SUBMIT",
      d = "@@modal-saga/CLICK",
      f = "@@modal-saga/HIDE",
      p = "@@modal-saga/DESTROY";

  var m = function m(e, t) {
    return Object.keys(t).filter(function (t) {
      return !e.includes(t);
    }).reduce(function (e, n) {
      return e[n] = t[n], e;
    }, {});
  },
      v = !1,
      b = function b(e) {
    return function () {
      return e;
    };
  },
      y = b(!0),
      h = (b(!1), function (e) {
    return e.charAt(0).toUpperCase() + e.slice(1);
  });

  var x = {},
      M = {
    props: {}
  },
      O = function O(e, t) {
    return e[t] || M;
  };

  function g() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : x,
        t = arguments.length > 1 ? arguments[1] : void 0;

    switch (t.type) {
      case c:
        var n = t.meta.name;
        return i()({}, e, a()({}, n, {
          props: t.payload,
          isOpen: !0
        }));

      case d:
        var r = t.meta.name;
        return i()({}, e, a()({}, r, i()({}, e[r], {
          clicked: t.payload
        })));

      case s:
        var o = t.meta.name,
            u = O(e, o);
        return i()({}, e, a()({}, o, i()({}, u, {
          props: i()({}, u.props, t.payload)
        })));

      case l:
        var v = t.meta.name,
            b = O(e, v);
        return i()({}, e, a()({}, v, i()({}, b, {
          props: i()({}, b.props),
          isSubmitted: !0,
          submitted: t.payload
        })));

      case f:
        var y = t.meta.name,
            h = O(e, y);
        return i()({}, e, a()({}, y, i()({}, h, {
          isOpen: !1
        })));

      case p:
        var M = t.meta.name;
        return m([M], e);

      default:
        return e;
    }
  }

  function j(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return {
      type: c,
      payload: t,
      meta: {
        name: e
      }
    };
  }

  function k(e) {
    return {
      type: f,
      meta: {
        name: e
      }
    };
  }

  function q(e, t) {
    return {
      type: d,
      payload: t,
      meta: {
        name: e
      }
    };
  }

  function S(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return {
      type: s,
      payload: t,
      meta: {
        name: e
      }
    };
  }

  function w(e) {
    return {
      type: p,
      meta: {
        name: e
      }
    };
  }

  function C(e, t) {
    return {
      type: l,
      payload: t,
      meta: {
        name: e
      }
    };
  }

  var P = n(8),
      A = n.n(P),
      E = n(9),
      T = n.n(E),
      D = n(10),
      _ = n.n(D),
      H = n(11),
      U = n.n(H),
      I = n(12),
      R = n.n(I),
      W = n(13),
      N = n.n(W),
      z = n(14),
      B = n.n(z),
      F = n(5),
      K = n.n(F),
      L = n(15),
      Y = n(6),
      G = n(16),
      J = n(17),
      Q = n.n(J),
      V = function V(e) {
    return e.modals;
  },
      X = function X(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : V;
    return function (n, r) {
      var o = t(n, r);
      return o && o[e];
    };
  },
      Z = n(7),
      $ = n.n(Z),
      ee = {
    showModal: "show",
    hideModal: "hide",
    destroyModal: "destroy",
    updateModal: "update",
    clickModal: "click",
    submitModal: "submit"
  },
      te = (Object.values(ee), ee);

  function ne(e, t, n) {
    return function () {
      for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++) {
        o[a] = arguments[a];
      }

      return "function" == typeof n ? n(e.apply(this, [t].concat(o))) : e.apply(this, [t].concat(o));
    };
  }

  function re(e, t, n) {
    if ("function" == typeof r) return ne(r, e, n);
    if ("object" !== $()(r) || null === r) throw new Error("createModalActions expected an object or a function, instead received ".concat(null === r ? "null" : $()(r), ". ") + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var o = {};

    for (var a in r) {
      var u = r[a],
          i = t || te,
          c = i[a] ? i[a] : a;
      "function" == typeof u && (o[c] = ne(u, e, n));
    }

    return o;
  }

  var oe = n(1),
      ae = {},
      ue = function ue(e) {
    var t = e.name,
        n = e.getModalsState,
        o = void 0 === n ? V : n,
        u = e.initProps,
        c = void 0 === u ? ae : u,
        s = e.actions,
        l = void 0 === s ? {} : s,
        d = e.destroyOnHide,
        f = void 0 === d || d,
        p = e.keepComponentOnHide,
        m = void 0 !== p && p;
    return function (e) {
      var n = function (n) {
        function r() {
          var e, t;
          T()(this, r);

          for (var n = arguments.length, o = new Array(n), u = 0; u < n; u++) {
            o[u] = arguments[u];
          }

          return t = U()(this, (e = R()(r)).call.apply(e, [this].concat(o))), a()(N()(t), "state", {
            isOpen: t.props.modal.isOpen
          }), t;
        }

        return B()(r, n), _()(r, [{
          key: "componentDidUpdate",
          value: function value(e) {
            var t = this.props.modal.isOpen;
            t !== e.modal.isOpen && this.setState({
              isOpen: t
            }), !1 === t && f && !m && this.props.destroy();
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            var e = this.props.modal.isOpen;
            e && this.props.hide(), e && f && this.props.destroy();
          }
        }, {
          key: "render",
          value: function value() {
            var n = this.state.isOpen,
                r = this.props,
                o = r.modal,
                a = A()(r, ["modal"]);
            return oe.undef(n) || !1 === n && !m ? null : K.a.createElement(e, i()({}, a, o.props, {
              modal: {
                name: t
              },
              isOpen: n
            }));
          }
        }]), r;
      }(F.Component);

      return a()(n, "propTypes", {
        modal: L.object.isRequired
      }), a()(n, "displayName", "ConnectedModal(".concat(function (e, t) {
        return e.displayName || e.name || t || "Component";
      }(e, t), ")")), Object(G.connect)(function (e) {
        return i()({}, c, {
          modal: o(e)[t] || ae
        });
      }, function (e) {
        return i()({}, Object(Y.bindActionCreators)(l, e), Object(Y.bindActionCreators)(r, e), re(t, te, e));
      })(Q()(n, e));
    };
  },
      ie = n(4),
      ce = n.n(ie),
      se = n(3),
      le = function le(e) {
    return function (t) {
      return e.some(function (e) {
        return ve(e)(t);
      });
    };
  },
      de = function de(e) {
    return function (t) {
      return e(t);
    };
  },
      fe = function fe(e) {
    return function (t) {
      return t === String(e);
    };
  },
      pe = function pe(e) {
    return function (t) {
      return t === e;
    };
  },
      me = function me() {
    return y;
  };

  function ve(e) {
    var t = "*" === e ? me : oe.undef(e) ? me : oe.string(e) ? fe : oe.array(e) ? le : oe.stringableFunc(e) ? fe : oe.func(e) ? de : oe.symbol(e) ? pe : null;
    if (null === t) throw new Error("invalid pattern: ".concat(e));
    return t(e);
  }

  function be(e, t, n, r) {
    var o = r.type,
        a = r.payload,
        u = r.meta;
    return o === t && u && u.name === e && ve(n)(a);
  }

  var ye = Object.keys(r);

  function he(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : te;
    return ye.reduce(function (n, o) {
      var a = r[o],
          u = t[o],
          i = a(e).type;
      return n[u] = function (t) {
        return oe.object(t) ? be(e, i, y, t) : function (n) {
          return be(e, i, t, n);
        };
      }, n;
    }, {});
  }

  function xe(e, t) {
    var n = t || he(e);
    return Object.keys(n).reduce(function (e, t) {
      var r = n[t];
      return e["take".concat(h(t))] = function (e) {
        return Object(se.take)(function (t) {
          return e ? r(e)(t) : r(t);
        });
      }, e;
    }, {});
  }

  function Me(e, t) {
    var n = i()({
      getModalsState: V,
      renameMap: te
    }, t),
        r = n.selector || X(e, n.getModalsState),
        o = i()({}, function (e, t) {
      return re(e, t, se.put);
    }(e, n.renameMap), xe(e, n.patterns));
    return o.select = function () {
      return Object(se.select)(r);
    }, o;
  }

  function Oe(e, t) {
    var n = ge(e, t);
    return i()({}, n, Me(e, {
      selector: n.selector,
      patterns: n.patterns
    }));
  }

  function ge(e, t) {
    var n = i()({
      getModalsState: V
    }, t);
    return {
      name: e,
      selector: X(e, n.getModalsState),
      patterns: he(e),
      actions: re(e)
    };
  }

  var je = ce.a.mark(ke);

  function ke() {
    var e,
        t,
        n,
        r,
        o = arguments;
    return ce.a.wrap(function (a) {
      for (;;) {
        switch (a.prev = a.next) {
          case 0:
            return e = o.length > 0 && void 0 !== o[0] ? o[0] : {}, t = o.length > 1 ? o[1] : void 0, n = Object.keys(e), a.next = 5, Object(se.all)(n.map(function (n) {
              var r = e[n],
                  o = Oe(n, t);
              return Object(se.fork)(ce.a.mark(function e() {
                var t, a;
                return ce.a.wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        return e.next = 3, Object(se.take)(o.patterns.show);

                      case 3:
                        return t = e.sent, a = t.payload, e.prev = 5, e.next = 8, Object(se.race)({
                          task: Object(se.call)([o, r], a),
                          cancel: o.takeDestroy()
                        });

                      case 8:
                        e.next = 15;
                        break;

                      case 10:
                        return e.prev = 10, e.t0 = e.catch(5), v && console.error("Error catched in the modal task ".concat(n, ": "), e.t0), e.next = 15, o.destroy();

                      case 15:
                        e.next = 0;
                        break;

                      case 17:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, null, [[5, 10]]);
              }));
            }));

          case 5:
            return r = a.sent, a.abrupt("return", r);

          case 7:
          case "end":
            return a.stop();
        }
      }
    }, je);
  }

  n.d(t, "sagaModal", function () {
    return ue;
  }), n.d(t, "reducer", function () {
    return g;
  }), n.d(t, "sagas", function () {
    return ke;
  }), n.d(t, "showModal", function () {
    return j;
  }), n.d(t, "hideModal", function () {
    return k;
  }), n.d(t, "clickModal", function () {
    return q;
  }), n.d(t, "updateModal", function () {
    return S;
  }), n.d(t, "createModal", function () {
    return Oe;
  }), n.d(t, "destroyModal", function () {
    return w;
  }), n.d(t, "submitModal", function () {
    return C;
  }), n.d(t, "createModalEffects", function () {
    return Me;
  }), n.d(t, "createTakeEffects", function () {
    return xe;
  }), n.d(t, "createModalPatterns", function () {
    return he;
  }), n.d(t, "createModalActions", function () {
    return re;
  }), n.d(t, "createModalHelpers", function () {
    return ge;
  }), n.d(t, "modalsStateSelector", function () {
    return V;
  }), n.d(t, "modalSelector", function () {
    return X;
  });
}]));